import { styled, Flex, Box } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const Wrapper = styled(Box)`
  border-radius: 12px;
  border: 1px solid #e0e0e8;
  background: #fff;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;

  ${(props) => props.styles}
`;

export const Header = styled(Box)`
  padding: 12px 16px;
  align-items: center;
  background: linear-gradient(104deg, #fbf6ff 0.49%, #eeeaff 99%);
  box-sizing: border-box;
`;

export const Content = styled(Flex)`
  padding: 16px;
  align-items: center;
  flex-direction: column;
  gap: 12px;
  box-sizing: border-box;
`;

export const MakeModel = styled(Text)`
  color: #040222;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

export const RegNumber = styled(Text)`
  color: #36354c;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;

export const Variant = styled(Text)`
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;

export const FieldValueWrapper = styled(Flex)`
  align-items: flex-start;
  justify-content: space-between;
`;

export const Field = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #5b5675;
`;

export const Value = styled(Text)`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #36354c;
  max-width: 45%;
  text-align: right;
`;

export const Divider = styled(Box)`
  border-top: 1px dashed #e0e0e8;
  height: 1px;
`;
